import Vue from 'vue';
import store from '@/store';
import * as types from './mutation-types';
import AuthorityProxy from "../../../proxies/AuthorityProxy";

/**
 * 권한 리스트
 * @param commit
 * @param param
 */
export const findAll = ({ commit },) => {
  new AuthorityProxy()
    .all()
    .then((response) => {
      commit(types.LIST, response);
    });
};

/**
 * 권한 추가
 * @param commit
 * @param param
 */
export const createAuthority = ({ commit }, param) => {
  new AuthorityProxy()
    .create(param)
    .then((response) => {
      if(response.header.returnCode === "OK") {
        store.dispatch('settingsAuthority/findAll');
      } else {
        alert(response.header.resultMessages);
      }
    });
};

/**
 * 권한 삭제
 * @param commit
 * @param param
 */
export const deleteAuthority = ({ commit }, param) => {
  new AuthorityProxy()
    .deleteAuthority(param.menuSeq, param.roleCode)
    .then((response) => {
      if(response.header.returnCode === "OK") {
        store.dispatch('settingsAuthority/findAll');
      } else {
        alert(response.header.resultMessages);
      }
    });
};

export default {
  findAll,
  createAuthority,
  deleteAuthority,
};
